<script>
import { RepairFile } from '@/models/RepairFile'
import RepairFileProspectService from '@/services/repairModule/repairFile/RepairFileProspectService'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import { auth as $store } from '@/store/AuthModule'
import SendProspectRequestModal from '@/components/modal/repair-file/step-prospect-request/SendProspectRequestModal.vue'
import AddProspectPictureByQRCodeModal from '@/components/modal/repair-file/step-prospect-request/AddProspectPictureByQRCodeModal.vue'
import AddProspectPictureByPCModal from '@/components/modal/repair-file/step-prospect-request/AddProspectPictureByPCModal.vue'
import Validator from '@/components/utils/validator'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'

export default {
  name: 'SubStepProspectRequest',
  components: {
    AddProspectPictureByPCModal,
    AddProspectPictureByQRCodeModal,
    SendProspectRequestModal
  },
  props: {
    currentRepairFile: RepairFile
  },
  data() {
    return {
      formProspectRequestValid: false,
      loading: false,

      categoryDetail: null,

      newDocumentList: [],
      newPictureList: [],

      additionalInfo: null,

      requiredRules: Validator.requiredRules
    }
  },
  async created() {
    this.loading = true
    if (this.currentRepairFile !== null) {
      const repairFileId = this.currentRepairFile.technical_id

      if (this.currentRepairFile.prospect_additional_info) {
        this.additionalInfo = this.currentRepairFile.prospect_additional_info
      } else {
        this.additionalInfo = this.currentRepairFile.breakdown_description
      }

      try {
        this.categoryDetail = await RepairFileProspectService.getCategoryDetailByRepairFileId(
          repairFileId
        )
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    filesMaximumCountRule() {
      return Validator.filesMaximumCountRule(this.currentRepairFile.prospect_document_list.length, 2)
    }
  },
  methods: {
    async submit() {},
    validationFormInputFile() {
      return !(
        this.categoryDetail?.prospectFolderPictureMandatory === 'yes' &&
        this.currentRepairFile.prospect_picture_list.length === 0
      )
    },
    async sendNewDocument() {
      this.loading = true
      const repairFileId = this.currentRepairFile.technical_id
      try {
        const formData = new FormData()
        const data = {
          repairFileId: repairFileId,
          requesterCollaboratorId: $store.state.currentCollaborator.technical_id
        }

        formData.append('data', JSON.stringify(data))
        if (this.newDocumentList && this.newDocumentList.length > 0) {
          this.newDocumentList.forEach((file, index) => {
            formData.append(`new_document_list_${index}`, file)
          })
        }
        await RepairFileProspectService.addNewDocumentToRepairFileProspect(formData)
        displayToast(
          this.$t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_DOCUMENT.ADD_SUCCESS'),
          'success'
        )
        this.newDocumentList = []
        this.$emit('refresh-repair-file')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async removeProspectDocument(documentTechnicalId) {
      this.loading = true
      const repairFileId = this.currentRepairFile.technical_id
      try {
        const data = {
          repair_file_id: repairFileId,
          prospect_document_id: documentTechnicalId,
          requestor_collaborator_id: $store.state.currentCollaborator.technical_id
        }

        await RepairFileProspectService.removeDocumentFromRepairFileProspect(data)
        displayToast(
          this.$t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_DOCUMENT.REMOVE_SUCCESS'),
          'success'
        )
        this.$emit('refresh-repair-file')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async removeProspectPicture(pictureTechnicalId) {
      this.loading = true
      const repairFileId = this.currentRepairFile.technical_id
      try {
        const data = {
          repair_file_id: repairFileId,
          prospect_picture_id: pictureTechnicalId,
          requestor_collaborator_id: $store.state.currentCollaborator.technical_id
        }

        await RepairFileProspectService.removePictureFromRepairFileProspect(data)
        displayToast(
          this.$t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_PICTURE.REMOVE_SUCCESS'),
          'success'
        )
        this.$emit('refresh-repair-file')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async openSendProspectRequestModal() {
      if (this.newDocumentList.length > 0) {
        await this.sendNewDocument()
      }

      const response = await this.$refs.sendProspectRequestModal.show({
        currentRepairFile: this.currentRepairFile,
        additionalInfo: this.additionalInfo
      })

      if (response.confirmed) {
        this.$emit('save-and-close-repair-file')
      }
    },
    async openQrCodePictureModal() {
      const response = await this.$refs.addProspectPictureByQRCodeModal.show({
        currentRepairFile: this.currentRepairFile
      })

      if (response.confirmed) {
        this.$emit('refresh-repair-file')
      }
    },
    async openPcPictureModal() {
      const response = await this.$refs.addProspectPictureByPCModal.show({
        currentRepairFile: this.currentRepairFile
      })

      if (response.confirmed) {
        this.$emit('refresh-repair-file')
      }
    },
    async updatePartialData() {
      try {
        const repairFileId = this.currentRepairFile.technical_id
        const data = {
          status_detail: RepairFileStatusDetailConstant.PROSPECT_CLIENT_INFORMATION_RETRIEVED,
          repair_file_id: this.currentRepairFile.technical_id,
          requestor_collaborator_id: $store.state.currentCollaborator.technical_id,
          additional_info: this.additionalInfo,
          is_complete_update: false
        }
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        await RepairFileProspectService.update(repairFileId, formData)

        displayToast(
          this.$t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.MESSAGE.PARTIAL_SUCCESS'),
          'success'
        )

        this.$router.push({ name: 'Dashboard', query: { skip: 'true' } })
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-form ref="formProspectRequest" v-model="formProspectRequestValid" @submit.prevent="submit">
    <v-row>
      <!--LEFT PART-->
      <v-col cols="12" md="4" class="text-center">
        <v-card outlined class="d-flex flex-column align-center justify-center photo-card">
          <p>{{ categoryDetail?.prospectCategoryDescription }}</p>
          <template v-if="categoryDetail?.prospectCategoryPicture">
            <v-img
              :src="categoryDetail.prospectCategoryPicture"
              class="picture"
              alt="Photo du produit de la demande préalable"
            />
          </template>
          <template v-else>
            <v-icon color="grey" size="48">mdi-image-off</v-icon>
            <p class="mt-2 text-muted">Pas de photo</p>
          </template>
        </v-card>
      </v-col>

      <!--RIGHT PART-->
      <v-col cols="8">
        <!--ADD Picture-->
        <v-row>
          <v-col cols="12">
            <v-row align="center">
              <v-col cols="12" md="12" class="pb-0">
                <p
                  :data-custom="categoryDetail?.prospectFolderPictureMandatory === 'yes'"
                  class="text-subtitle-3"
                >
                  {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_PICTURE.TITLE') }}
                </p>
                <p class="text-subtitle-2 mb-0">
                  {{
                    $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_PICTURE.SUBTITLE')
                  }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  :label="
                    $t(
                      'STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_PICTURE.INPUT_LABEL_BY_QR_CODE'
                    )
                  "
                  :disabled="currentRepairFile.prospect_picture_list.length >= 6"
                  append-inner-icon="mdi-camera"
                  @click="openQrCodePictureModal()"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  :label="
                    $t(
                      'STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_PICTURE.INPUT_LABEL_BY_PC'
                    )
                  "
                  :disabled="currentRepairFile.prospect_picture_list.length >= 6"
                  append-inner-icon="mdi-download"
                  @click="openPcPictureModal()"
                />
              </v-col>
            </v-row>
            <v-row
              class="chip-container pb-3"
              v-if="currentRepairFile.prospect_picture_list.length > 0"
            >
              <v-col
                v-for="prospectPicture of currentRepairFile.prospect_picture_list"
                :key="prospectPicture.technicalId"
                class="prospect-file-chip"
              >
                <v-chip append-icon="mdi-close" class="clickable-chip">
                  {{
                    $t(
                      'STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_PICTURE.PICTURE_NAME_LABEL'
                    )
                  }}{{ prospectPicture.pictureCounter }}
                  <template v-slot:append>
                    <v-icon
                      @click="removeProspectPicture(prospectPicture.technicalId)"
                      class="append-icon"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-chip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- More info -->
        <v-row align="center">
          <v-col cols="12" md="12">
            <p data-custom="true" class="text-subtitle-3">
              {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.MORE_INFO.TITLE') }}
            </p>
            <p class="mb-3 text-subtitle-3">
              {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.MORE_INFO.SUBTITLE') }}
            </p>
            <v-textarea
              :placeholder="
                $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.MORE_INFO.INPUT_LABEL')
              "
              :counter="500"
              :maxlength="500"
              v-model.trim="additionalInfo"
              auto-grow
              rows="4"
              :rules="requiredRules"
              hide-details
            />
          </v-col>
        </v-row>

        <!-- Add Document-->
        <v-row align="center">
          <v-col cols="12" md="12">
            <p class="mb-3 text-subtitle-3">
              {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_DOCUMENT.TITLE') }}
            </p>
            <v-row>
              <v-col cols="12" md="6">
                <v-file-input
                  :label="
                    $t(
                      'STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_DOCUMENT.INPUT_LABEL'
                    )
                  "
                  append-inner-icon="mdi-download"
                  multiple
                  v-model="newDocumentList"
                  :rules="filesMaximumCountRule"
                  :disabled="currentRepairFile.prospect_document_list.length >= 2"
                  chips
                  counter
                  show-size
                />
              </v-col>
            </v-row>
            <v-row
              class="chip-container"
              v-if="currentRepairFile.prospect_document_list.length > 0"
            >
              <v-col
                v-for="prospectDocument of currentRepairFile.prospect_document_list"
                :key="prospectDocument.technicalId"
                class="prospect-file-chip"
              >
                <v-chip append-icon="mdi-close" class="clickable-chip">
                  {{
                    $t(
                      'STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_DOCUMENT.DOCUMENT_NAME_LABEL'
                    )
                  }}{{ prospectDocument.documentCounter }}
                  <template v-slot:append>
                    <v-icon
                      @click="removeProspectDocument(prospectDocument.technicalId)"
                      class="append-icon"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-chip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-btn
      :disabled="!formProspectRequestValid || !validationFormInputFile() || loading"
      :loading="loading"
      class="boom-button mt-4 pl-15 pr-15"
      variant="outlined"
      @click="openSendProspectRequestModal()"
    >
      {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.BUTTON.VALIDATE') }}
    </v-btn>
  </v-form>

  <SendProspectRequestModal ref="sendProspectRequestModal" />
  <AddProspectPictureByQRCodeModal ref="addProspectPictureByQRCodeModal" />
  <AddProspectPictureByPCModal ref="addProspectPictureByPCModal" />
</template>

<style scoped>
.photo-card {
  margin: auto;
  padding: 10px;
  box-shadow: none;
  border: solid 1px #e4e4e4;
  border-radius: 12px;
  background-color: #e4e4e4;
}

:deep(.picture) {
  height: 250px !important;
  width: 250px !important;
}

h3[data-custom='true']:after {
  content: ' *';
  color: var(--error-color);
}

.text-subtitle-2 {
  margin-bottom: 16px;
  color: #666;
}

.text-subtitle-3 {
  color: black;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-content: center;
  flex-wrap: nowrap;
  align-items: center;
}

.prospect-file-chip {
  padding: 1px;
  max-width: 125px;
}

:deep(.clickable-chip .v-chip__append) {
  cursor: pointer;
}

.chip-container {
  margin-left: 0;
}
</style>
